export default __webpack_public_path__ + "media/zeeLearn.980bd6f5.png";